module.exports = __webpack_public_path__ + "img/arrow_right.829ffbb0.png";